import { getCookie, setCookie } from './useCookies';

let securityKey = null;

function getManifest() {
  const manifest = document.querySelector('link[rel="manifest"]');
  if (manifest) {
    manifest.href = `${manifest.href}?key=${securityKey}`;
  }
}

export default function useSecurityKey() {
  function handleKey() {
    const urlParams = new URLSearchParams(window.location.search);
    const queryKey = urlParams.get('key');

    if (queryKey) {
      securityKey = queryKey;
      // Save to cookie if not already present
      const cookieKey = getCookie('securityKey');
      if (!cookieKey || cookieKey !== queryKey) {
        setCookie('securityKey', queryKey);
      }

      getManifest();

      return queryKey;
    }

    const cookieKey = getCookie('securityKey');
    if (cookieKey) {
      securityKey = cookieKey;
      getManifest();
      return cookieKey;
    }
  }

  function getKey() {
    if (securityKey) {
      return securityKey;
    } else {
      return handleKey();
    }
  }

  return {
    handleKey,
    getKey,
  };
}
